import React from "react"
import { ExternalLinkWrapper } from "../ExternalLinkWrapper"
import { BodyTextRegular } from "../typography/text"
import { css, useTheme } from "@emotion/react"
import { Link, useI18next } from "gatsby-plugin-react-i18next"

type Props = {
  href: string
  children: React.ReactNode
  internalLink?: boolean
}

export const FooterLink = ({ href, children, internalLink = false }: Props) => {
  const theme = useTheme()
  const { language } = useI18next()
  const linkStyle = css`
    color: ${theme.colors.primary};
    cursor: pointer;
    text-decoration: none;
    ${theme.bp.mobile} {
      padding-bottom: 8px;
    }
    ${theme.bp.desktop} {
      padding-left: 8px;
      margin-left: 8px;
    }
    &:hover {
      color: ${theme.colors.ctaMain};
    }
  `

  if (internalLink) {
    return (
      <Link css={linkStyle} to={href} language={language}>
        <BodyTextRegular>{children}</BodyTextRegular>
      </Link>
    )
  }

  return (
    <ExternalLinkWrapper css={linkStyle} href={href}>
      <BodyTextRegular>{children}</BodyTextRegular>
    </ExternalLinkWrapper>
  )
}
